import { render } from "./MissionGameMatch.vue?vue&type=template&id=9a56ca60&scoped=true"
import script from "./MissionGameMatch.vue?vue&type=script&lang=js"
export * from "./MissionGameMatch.vue?vue&type=script&lang=js"

import "./MissionGameMatch.vue?vue&type=style&index=0&id=9a56ca60&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a56ca60"]])

export default __exports__